import React from "react";
import * as Styled from "./FormAccordion.styled";
import { Checkbox, Stack } from "@mui/material";

const FormAccordion = ({
    title,
    isChecked,
    withCheckBox = true,
    children,
    onChange,
    ...props
}: any) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    return (
        <Styled.Container className="p-3" {...props}>
            <Styled.Header>
                <Stack direction="row" alignItems="center">
                    {withCheckBox && (
                        <Checkbox
                            color="default"
                            checked={isChecked}
                            onChange={handleChange}
                        />
                    )}
                    <Styled.Title
                        onClick={() => {
                            onChange(!isChecked);
                        }}
                    >
                        {title}
                    </Styled.Title>
                </Stack>
            </Styled.Header>
            <Styled.Content
                style={{
                    display: isChecked || !withCheckBox ? "block" : "none",
                }}
            >
                {children}
            </Styled.Content>
        </Styled.Container>
    );
};

export default FormAccordion;
